module.exports = __webpack_public_path__ + "img/navbg.9fd12449.jpg";